import {combine, forward, sample} from 'effector';

import {RestError, showRestError} from 'core/errors';

import {loadFactoryFx} from '../factoryDetails';

import {
    addFactoryLine,
    addFactoryLineFx,
    dateRange$,
    factory$,
    factoryLine$,
    factoryLineDynamicStatistics$,
    FactoryLineGate,
    loadFactoryLineDynamicFx,
    loadFactoryLineFx,
} from './index';

// Future API
// loadFactoryLineActivityFx.use((params) => fetchFactoryLineActivity(params.id));
// factoryLineActivity$
//     .on(loadFactoryLineActivityFx.doneData, (_, data) => data)
//     .reset(EquipmentTabGate.close);

factoryLine$.on(loadFactoryLineFx.doneData, (_, data) => data).reset(FactoryLineGate.close);
factory$.on(loadFactoryFx.doneData, (_, data) => data).reset(FactoryLineGate.close);
factoryLineDynamicStatistics$
    .on(loadFactoryLineDynamicFx.doneData, (_, data) => data)
    .reset(FactoryLineGate.close);

forward({
    from: addFactoryLine,
    to: addFactoryLineFx,
});

sample({
    clock: FactoryLineGate.open,
    source: FactoryLineGate.state,
    fn: (state) => ({factoryId: state.factoryId, lineId: state.lineId}),
    target: loadFactoryLineFx,
});

sample({
    clock: FactoryLineGate.open,
    source: FactoryLineGate.state,
    fn: (state) => ({id: state.factoryId}),
    target: loadFactoryFx,
});

sample({
    clock: FactoryLineGate.open,
    source: combine({gate: FactoryLineGate.state, dateRange: dateRange$}),
    fn: (state) => ({
        id: Number(state.gate.factoryId),
        from: state.dateRange.start,
        to: state.dateRange.end,
    }),
    target: loadFactoryLineDynamicFx,
});

addFactoryLineFx.fail.watch(({error}) => showRestError(error as RestError));
